<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      @if(idUploadService.idSide.value === 'FRONT') {
        @if((SidesForDocType.get(idUploadService.selectedDocType()) ?? 0) === 1) {
          <h1 class="vtz-h1" i18n>ID Verification</h1>
        } @else {
          <h1 class="vtz-h1" i18n>ID Verification: FRONT</h1>
        }
      } @else if(idUploadService.idSide.value === 'BACK') {
        <h1 class="vtz-h1" i18n>ID Verification: BACK</h1>
      } @else {
        <h1 class="vtz-h1" i18n>ID Verification</h1>
      }
    @if(uploadMethod === 'UNSELECTED') {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        To confirm your identity, you will need to upload a picture of official photo identification and a picture of yourself.
      </p>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        Which type of photo identification are you using?
      </p>
      <form [formGroup]="docTypeForm" class="vtz-form">
        <div class="vtz-form__row">
          <div class="vtz-form__item">
            
            <select class="vtz-form__select" formControlName="selectedDocType" name="docTypeForm" id="docTypeForm">
              <option value="null">Select</option>
              @for (optionValue of pickerOptions(); track optionValue; let i = $index) {
                <option [value]="docTypeOptions[i]">{{optionValue}}</option>
              }
            </select>
          </div>
        </div>
      </form>
      @if(idUploadService.selectedDocType() !== "null") {
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          You may take a picture of your {{idUploadService.selectedDocTypeString()}} or upload an image file. Which method do you prefer?
        </p><br>
        <div class="button-group-responsive">
          <button class="button button-primary" (click)="setMethod('CAMERA')" i18n="Button label">
            PICTURE
          </button>
          <button class="button button-primary" (click)="setMethod('FILE')" i18n="Button label">
            UPLOAD
          </button>
        </div>
      }
    }

    @if(uploadMethod === 'CAMERA') {
      @if(idUploadService.idSide.value === 'FRONT') {
        @if((SidesForDocType.get(idUploadService.selectedDocType()) ?? 0) === 1) {
          <p class="vtz-text vtz-text--center" i18n>
            Please use your webcam to take a clear photo of your {{idUploadService.selectedDocTypeString()}}.
          </p>
        } @else {
          <p class="vtz-text vtz-text--center" i18n>
            Please use your webcam to take a clear photo of the FRONT of your {{idUploadService.selectedDocTypeString()}}.
          </p>
        } 
      } @else {
        <p class="vtz-text vtz-text--center" i18n>
          Please use your webcam to take a clear photo of the BACK of your {{idUploadService.selectedDocTypeString()}}.
        </p>
      }
      @if(idUploadService.uploadState.showWebcam && (idUploadService.uploadState.errors.length < 1) && !idUploadService.uploadState.webcamImage.getValue()) {
        <webcam [height]="382" [width]="650" [trigger]="triggerObservable" (imageCapture)="idUploadService.handleImage($event)"
        [imageQuality]="0.5" [allowCameraSwitch]="browserSupportService.switchCameraSupported"
        (initError)="idUploadService.handleInitError($event)"></webcam>
      }
      @if(idUploadService.uploadState.errors.length > 0) {
        <div class="vtz-webcam__instructions-frame">
          <div class="vtz-webcam__instructions">
            <p class="vtz-text vtz-text--bold vtz-text--italic" i18n>There was a problem with your camera. Please make sure it is working properly and check the permissions in your browser settings.</p>
          </div>
        </div>
      }
      @if((idUploadService.uploadState.errors.length < 1) && !idUploadService.uploadState.webcamImage.getValue() && !idUploadService.uploadState.retake && !idUploadService.uploadState.showWebcam) {
        <div class="vtz-webcam__instructions-frame vtz-webcam__instructions--photo-tips">
          <p class="vtz-webcam__photo-tips vtz-text--bold" i18n>Photo Tips:</p>
          <p class="vtz-webcam__photo-tips" i18n>Align your {{idUploadService.selectedDocTypeString()}} with the frame.</p>
          <p class="vtz-webcam__photo-tips" i18n>Use the Camera button to capture your image and review the photo.</p>
        </div>
      }
      @if(idUploadService.uploadState.webcamImage.getValue() && !idUploadService.uploadState.retake) {
        <div class="vtz-webcam__snapshot">
          <img [src]="idUploadService.uploadState.webcamImage.getValue()!.imageAsDataUrl">
          <br><br>
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Click “UPLOAD ID” to proceed with this photo or “RETAKE” to try again.</p>
        </div>
      }
      <div class="vtz-actions">
        @if(!idUploadService.uploadState.webcamImage.getValue()) {
          <div id="vtz-button-group" class="button-group-responsive">
            <button class="button button-primary" (click)="back()" i18n="Button label">BACK</button>
            @if(!idUploadService.uploadState.showWebcam && !idUploadService.uploadState.webcamImage.getValue() || (idUploadService.uploadState.errors.length > 0)) {
              <button [disabled]="idUploadService.uploadState.errors.length > 0" class="button button-primary" (click)="idUploadService.toggleWebcam()" i18n="Toggle camera button">BEGIN</button>
            }
            @if(idUploadService.uploadState.showWebcam && !idUploadService.uploadState.webcamImage.getValue() && (idUploadService.uploadState.errors.length < 1)) {
              <button class="button button-primary button-camera" (click)="idUploadService.triggerSnapshot()"></button>
            }
            <br>
          </div>
        }
        @if(idUploadService.uploadState.webcamImage.getValue()) {
          <div id="vtz-button-group" class="button-group-responsive">
            <button class="button button-primary" (click)="back()" i18n="Button label">
              BACK
            </button>
            <button id="cancel-button" class="button-secondary" (click)="idUploadService.retakePhoto()" i18n="Button label">
              RETAKE
            </button>
            <button id="submit-button" class="button-primary"  i18n="Button label" (click)="continue($event)">
              UPLOAD ID
            </button>
          </div>
        }
      </div>
    }
    
    @if(uploadMethod === 'FILE') {
      @if(idUploadService.idSide.value === 'FRONT') {
        @if((SidesForDocType.get(idUploadService.selectedDocType()) ?? 0) === 1){
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Attach an image of your {{idUploadService.selectedDocTypeString()}} that shows your face. JPEG and PNG formats are allowed. Maximum file size is 3MB.
          </p>
        } @else {
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Attach an image of the FRONT of your {{idUploadService.selectedDocTypeString()}}. JPEG and PNG formats are allowed. Maximum file size is 3MB.
          </p>
        }
    }
    @if(idUploadService.idSide.value === 'BACK') {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        Attach an image of the BACK of your {{idUploadService.selectedDocTypeString()}}. JPEG and PNG formats are allowed. Maximum file size is 3MB.
      </p>
    }
      <div >
        <app-drag-and-drop (fileUploaded)="handleFileUploaded($event)" [cleanSignal]="cleanDragAndDrop()"></app-drag-and-drop>       
      </div>
      <div class="vtz-actions">
        <div style="margin-top:10px"></div>
        <div class="button-group">
          <button class="button button-primary" (click)="back()" i18n="Button label">
              BACK
          </button>
        </div>
      </div>
    }
  </main>
  </div>
</div>
<app-id-upload-modal [isOpen]="isOpen" [uploadMethod]="'FILE'" [file]="idUploadService.selectedFile"></app-id-upload-modal>
<app-id-upload-modal [isOpen]="isOpenCamera" [uploadMethod]="'CAMERA'" [snapshot]="idUploadService.uploadState.webcamImage"></app-id-upload-modal>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>